export default __webpack_public_path__ + "static/media/d6.699b9040.png";